import React from 'react';
import { change, getFormValues, reduxForm } from 'redux-form/immutable';

// components
import { Link } from 'react-router';
import AppointmentsLimit from '../../shared/managers/_AppointmentsLimit';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Button from '../../shared/form/_Button';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { currentManagerValidate } from '../../../actions/currentManagerActions';

const FORM_NAME = 'managerNew';

const AppointmentLimit = ({ changeFormData, formValues, currentUser, token, validateCurrentManager, _handleGoBack }) => {
  const loading = currentUser.get('loading') || token.get('loading');

  return (
    <div className='manager-new__step1'>
      <h2 className='manager-new__step3__description'>
            Appointments limit:
      </h2>
      <form className='manager-new__step3__form' onSubmit={ _handleSubmit(validateCurrentManager, formValues) }>
        {formValues ? <AppointmentsLimit changeFormData={ changeFormData } formValues={ formValues } name={ 'office' } /> :
        <div>You need to fill in your previous steps first</div>}
        <div className='form__submit'>
          <Link className={ classNames('form__button form__button--purple manager-new__form__button', { 'form__button--disabled': loading }) }
            to={ _handleGoBack }>
                Back
          </Link>
          <Button className='form__button form__button--green manager-new__form__button'
            loading={ loading }>
                Next
          </Button>
        </div>
      </form>

    </div>
  );
};

AppointmentLimit.propTypes = {
  _handleBack: PropTypes.func,
  changeFormData: PropTypes.func.isRequired,
  currentUser: PropTypes.instanceOf(Immutable.Map),
  formValues:  PropTypes.instanceOf(Immutable.Map),
  token: PropTypes.PropTypes.instanceOf(Immutable.Map)
};

const _handleSubmit = (validateCurrentManager, formValues) => (e) => {
  e.preventDefault();
  const form = formValues || Immutable.Map();

  validateCurrentManager(form.toJS());
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues:  getFormValues(FORM_NAME)(state),
    token:       state.get('token'),
    routingParams: state.getIn(['routing', 'locationBeforeTransitions']).query

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFormData: (state, value) => dispatch(change(FORM_NAME, state, value)),
    validateCurrentManager: (form) => dispatch(currentManagerValidate(form))
  };
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
      {
        destroyOnUnmount: false,
        form: FORM_NAME
      }
    )(AppointmentLimit)
  ));



// WEBPACK FOOTER //
// ./app/components/managers/signUp/_AppointmentLimit.jsx